module.exports = __webpack_public_path__ + "static/img/m_name.bd10a8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/wxsjglm/m_name.png
// module id = zRMn
// module chunks = 7